import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const IconPlus = () => {
    return (
        <svg
            fill='none'
            height='12'
            viewBox='0 0 12 12'
            width='12'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M6.625 0H5.375V5.375H0V6.625H5.375V12H6.625V6.625H12V5.375H6.625V0Z'
                fill='#FC5200'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconPlus;
